import { render } from "./AnnouncementBox.vue?vue&type=template&id=e08e1a6a"
import script from "./AnnouncementBox.vue?vue&type=script&lang=js"
export * from "./AnnouncementBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__